import apiFetch from '../apiFetch'

export default function (token, campaign) {
  return apiFetch({ endPoint: 'CampaignGroup/Create', method: 'POST', body: campaign, token: token })
}
